import { NgModule } from "@angular/core";
import { Routes, RouterModule, ExtraOptions } from "@angular/router";

const routes: Routes =
	[
		// commons
		//----------------------------------------------------------

		// not found
		{
			path: 'notfound',
			loadChildren: () => import('./shared/common-pages/page-not-found/pagenotfound.module').then(m => m.PageNotFoundModule),
		},
		// forbidden
		{
			path: 'forbidden',
			loadChildren: () => import('./shared/common-pages/forbidden/forbidden.module').then(m => m.ForbiddenModule)
		},

		// webapp
		//----------------------------------------------------------

		// dashboard
		{
			path: "dashboard",
			loadChildren: () => import('./reserved-area/layout/layout.module').then(m => m.ReservedAreaLayoutModule)
		},
		// funnel
		{
			path: "",
			loadChildren: () => import('./funnel/layout/layout.module').then(m => m.FunnelLayoutModule)
		},

		// other
		//----------------------------------------------------------
		{
			path: "**",
			redirectTo: "notfound"
		}
	];

const routerOptions: ExtraOptions =
{
	useHash: false,
	anchorScrolling: 'enabled',
	scrollPositionRestoration: 'enabled',
	bindToComponentInputs: true
};

@NgModule({
	imports:
		[
			RouterModule.forRoot(routes, routerOptions)
		],
	exports: [RouterModule]
})
export class AppRoutingModule { }
